import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ApiService } from '../../services/api-services/api.service';
import { UserStore } from '../../stores/user.store';
import { ToastService } from '../../services/toast-service/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { SuccessErrorReportModalComponent } from '../success-error-report-modal/success-error-report-modal.component';

@Component({
  selector: 'app-error-section',
  templateUrl: './error-section.component.html',
  styleUrls: ['./error-section.component.scss'],
})
export class ErrorSectionComponent implements OnInit {
  @Input() errorMessage!: string;

  private apiService = inject(ApiService);
  private userStore = inject(UserStore);
  private modalController = inject(ModalController);

  constructor() {}

  ngOnInit() {}

  reportMsProblem() {
    this.apiService
      .reportMSProblem({
        upn: this.userStore.user()?.userPrincipalName,
        userId: this.userStore.user()?.microsoftUserId,
        time: new Date().toUTCString(),
      })
      .subscribe(() => {
        this.modalController
          .create({
            component: SuccessErrorReportModalComponent,
            backdropDismiss: true,
          })
          .then((modal) => modal.present());
      });
  }
}
